import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "../ui/button";
import { useConsultation } from "../../context/ConsultationContext";

export const ConsultationCTA = ({ demoLabel }) => {
  const { openWith } = useConsultation();
  return (
    <section className="mt-16" data-testid={`cta-build-${demoLabel}`}>
      <div className="relative overflow-hidden rounded-3xl bg-primary text-primary-foreground p-10 md:p-14">
        <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full bg-accent/25 blur-3xl" />
        <div className="absolute -bottom-20 -left-10 w-80 h-80 rounded-full bg-white/10 blur-3xl" />
        <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-semibold uppercase tracking-wider">
              <Sparkles className="w-3.5 h-3.5" /> Ready when you are
            </div>
            <h3 className="mt-4 font-display text-3xl sm:text-4xl leading-tight">
              Let's build this for your business.
            </h3>
            <p className="mt-3 text-primary-foreground/85">
              A StaffLink specialist will tailor this automation to your operations,
              connect it to your systems and get you live — usually within 2 weeks.
            </p>
          </div>
          <Button
            size="lg"
            variant="secondary"
            className="bg-white text-primary hover:bg-white/90 text-base font-semibold h-12 px-6"
            onClick={() => openWith({ interested_demo: demoLabel })}
            data-testid={`open-consultation-${demoLabel}`}
          >
            Book Free Consultation <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ConsultationCTA;
